export const SET_WORLD_FIRST_TRACKER_DATA = 'WORLD_FIRST_TRACKER/SET_DATA';
export const SHOW_WORLD_FIRST_TRACKER_SPINNER = 'WORLD_FIRST_TRACKER/SHOW_SPINNER';
export const FORCE_WORLD_FIRST_REFRESH = 'WORLD_FIRST_TRACKER/FORCE_REFRESH';

// Action Creators
const WorldFirstTrackerActions = {
  setWorldFirstTracker(data: any) {
    return {
      type: SET_WORLD_FIRST_TRACKER_DATA,
      payload: data
    };
  },
  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_WORLD_FIRST_TRACKER_SPINNER,
      payload: show
    };
  },
  forceRefresh() {
    return {
      type: FORCE_WORLD_FIRST_REFRESH,
      payload: null
    };
  }
};

export default WorldFirstTrackerActions;
